module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "21bf":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof global !== 'undefined' && global.crypto) {
	        crypto = global.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(0);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "6119":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "94f8":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("21bf"));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ "c1bc":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("21bf"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64url encoding strategy.
	     */
	    var Base64url = C_enc.Base64url = {
	        /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */
	        stringify: function (wordArray, urlSafe=true) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = urlSafe ? this._safe_map : this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */
	        parse: function (base64Str, urlSafe=true) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = urlSafe ? this._safe_map : this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                reverseMap = this._reverseMap = [];
	                for (var j = 0; j < map.length; j++) {
	                    reverseMap[map.charCodeAt(j)] = j;
	                }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	        _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	        var words = [];
	        var nBytes = 0;
	        for (var i = 0; i < base64StrLength; i++) {
	            if (i % 4) {
	                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	                var bitsCombined = bits1 | bits2;
	                words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	                nBytes++;
	            }
	        }
	        return WordArray.create(words, nBytes);
	    }
	}());

	return CryptoJS.enc.Base64url;

}));

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "cebe":
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "ebc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_security_loader_vue_vue_type_style_index_0_id_532422b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6119");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_security_loader_vue_vue_type_style_index_0_id_532422b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_security_loader_vue_vue_type_style_index_0_id_532422b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_security_loader_vue_vue_type_style_index_0_id_532422b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__("cebe");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// EXTERNAL MODULE: ./node_modules/crypto-js/sha256.js
var sha256 = __webpack_require__("94f8");
var sha256_default = /*#__PURE__*/__webpack_require__.n(sha256);

// EXTERNAL MODULE: ./node_modules/crypto-js/enc-base64url.js
var enc_base64url = __webpack_require__("c1bc");
var enc_base64url_default = /*#__PURE__*/__webpack_require__.n(enc_base64url);

// CONCATENATED MODULE: ./src/plugin-security-agrial/common/random.js
// https://github.com/IdentityModel/oidc-client-js/blob/dev/src/random.js

/**
 * Generates RFC4122 version 4 guid ()
 */
var random_crypto = typeof window !== 'undefined' ? window.crypto || window.msCrypto : null;

function _cryptoUuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ random_crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

function _uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ Math.random() * 16 >> c / 4).toString(16);
  });
}

function random() {
  var hasCrypto = random_crypto != null;
  var hasRandomValues = hasCrypto && typeof random_crypto.getRandomValues !== 'undefined';
  var uuid = hasRandomValues ? _cryptoUuidv4 : _uuidv4;
  return uuid().replace(/-/g, '');
}
// CONCATENATED MODULE: ./src/plugin-security-agrial/common/utils.js




function getUrlParameter(searchUrl, name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(searchUrl);
  return results != null ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
}
function generateData() {
  var codeVerifier = random() + random() + random();
  return {
    state: random(),
    codeVerifier: codeVerifier,
    codeChallenge: enc_base64url_default.a.stringify(sha256_default()(codeVerifier))
  };
}
function getRedirectRoute(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var route = "".concat("/login-callback", "-").concat(type);

  if (Object.keys(params).length > 0) {
    route += "?".concat(Object.keys(params).map(function (key) {
      return "".concat(key, "=").concat(encodeURIComponent(params[key]));
    }).join('&'));
  }

  return route;
}
function getSecurityInfos(redirectRoute, state, codeChallenge) {
  return external_axios_default.a.get("/security/infos").then(function (response) {
    var _response$data = response.data,
        endpoint = _response$data.endpoint,
        clientId = _response$data.clientId;
    var params = {
      client_id: clientId,
      redirect_uri: "".concat(window.location.origin).concat(redirectRoute),
      state: state,
      code_challenge: codeChallenge,
      response_type: 'code',
      scope: 'openid',
      code_challenge_method: 'S256',
      response_mode: 'query'
    };
    return "".concat(endpoint, "?").concat(Object.keys(params).map(function (key) {
      return "".concat(key, "=").concat(encodeURIComponent(params[key]));
    }).join('&'));
  });
}
// CONCATENATED MODULE: ./src/plugin-security-agrial/lib/oidc-manager.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var oidc_manager_default =
/*#__PURE__*/
function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, [{
    key: "signinPopup",
    value: function signinPopup() {
      var _generateData = generateData(),
          state = _generateData.state,
          codeVerifier = _generateData.codeVerifier,
          codeChallenge = _generateData.codeChallenge;

      var popup = window.open('', '_blank', 'location=no,toolbar=no,width=510,height=700,left=100,top=20;');
      return new Promise(function (resolve, reject) {
        getSecurityInfos(getRedirectRoute('popup'), state, codeChallenge).then(function (oidcUrl) {
          popup.window.location = oidcUrl;
          window["oidc-".concat(state)] = {
            codeVerifier: codeVerifier,
            success: function success() {
              clearInterval(checkPopupInterval);
              delete window["oidc-".concat(state)];
              popup.close();
              resolve(true);
            },
            failure: function failure(error) {
              clearInterval(checkPopupInterval);
              delete window["oidc-".concat(state)];
              popup.close();
              reject(error);
            }
          };
          var checkPopupInterval = setInterval(function () {
            if (window["oidc-".concat(state)] && popup.closed) {
              resolve(false);
            }
          }, 500);
        }, function (error) {
          popup.close();
          reject(error);
        });
      });
    }
  }, {
    key: "signinRedirect",
    value: function signinRedirect(options) {
      var _generateData2 = generateData(),
          state = _generateData2.state,
          codeVerifier = _generateData2.codeVerifier,
          codeChallenge = _generateData2.codeChallenge;

      return new Promise(function (resolve, reject) {
        var params = {};

        if (options.redirectUri != null) {
          params.successRedirectUri = _typeof(options.redirectUri) === 'object' ? JSON.stringify(options.redirectUri) : options.redirectUri;
        }

        getSecurityInfos(getRedirectRoute('redirect', params), state, codeChallenge).then(function (oidcUrl) {
          window.localStorage.setItem("oidc-".concat(state), codeVerifier);
          window.location = oidcUrl;
          resolve();
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var refreshToken = window.localStorage.getItem('refreshToken');

      if (refreshToken == null) {
        return Promise.reject(new Error('No refresh token in localstorage'));
      } else {
        return external_axios_default.a.get("/security/refresh", {
          params: {
            refresh_token: refreshToken
          }
        }).then(function (response) {
          var refreshToken = response.data.refreshToken;
          window.localStorage.setItem('refreshToken', refreshToken);
          return refreshToken;
        });
      }
    }
  }, {
    key: "signout",
    value: function signout() {
      var refreshToken = window.localStorage.getItem('refreshToken');
      return external_axios_default.a.get("/security/logout", {
        params: {
          refresh_token: refreshToken
        }
      });
    }
  }]);

  return _default;
}();


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"42fe2872-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/views/login-auto.vue?vue&type=template&id=408866e6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SecurityLoader',[_vm._v("Redirection")])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-auto.vue?vue&type=template&id=408866e6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"42fe2872-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/common/security-loader.vue?vue&type=template&id=532422b6&scoped=true&
var security_loadervue_type_template_id_532422b6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"security-loader"},[_c('svg',{staticClass:"security-logo",attrs:{"viewBox":"0 0 220 151","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("Group 85")]),_c('desc',[_vm._v("Created with Sketch.")]),_c('defs',[_c('polygon',{attrs:{"id":"path-1","points":"0.473001198 0.407220513 137.662024 0.407220513 137.662024 31.3618872 0.473001198 31.3618872"}}),_c('polygon',{attrs:{"id":"path-3","points":"0.222174792 0.22302644 15.8002831 0.22302644 15.8002831 14 0.222174792 14"}})]),_c('g',{attrs:{"id":"Charte","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"1_agrial_dashboard_auth","transform":"translate(-329.000000, -250.000000)"}},[_c('g',{attrs:{"id":"Group-85","transform":"translate(329.000000, 250.000000)"}},[_c('path',{attrs:{"d":"M43,97.1256495 C40.2618195,96.9892376 39.3895006,96.4822129 37.399139,93.1261531 L21.9046249,67 L20.6596251,67 L7.71654158,89.5835542 C6.53379176,91.6059008 4.60568022,94.9644258 3.17474951,96.1132436 C2.05343061,96.9892376 0.995999848,97.079631 0,97.1256495 L0,98 L12.3222218,98 L12.3222218,97.1256495 C11.0141529,97.1256495 8.0908606,97.1256495 8.0908606,95.1945181 C8.0908606,94.6883151 8.2767915,94.0432351 8.58804145,93.4466387 L11.4507219,88.0641236 L27.7544859,88.0641236 L30.3050973,92.4810731 C30.6794164,93.1261531 31.4870281,94.6414749 31.4870281,95.3794136 C31.4870281,97.079631 29.4344165,97.1256495 27.1328051,97.1256495 L27.1328051,98 L43,98 L43,97.1256495 Z M12.5081527,86.1798325 L19.6636253,73.5313328 L26.8821669,86.1798325 L12.5081527,86.1798325 Z","id":"Fill-1","fill":"#00713B"}}),_c('path',{attrs:{"d":"M83,82.766759 C80.2701715,82.9548432 78.6566085,83.0459853 78.6566085,86.3403589 L78.6566085,95.660884 C78.6566085,96.3113073 70.4058794,99 63.582533,99 C57.4393981,99 50.5539915,97.6080112 46.1485399,94.0377256 C42.8609869,91.3490329 41,88.6122835 41,82.536418 C41,74.7437663 49.0653653,67 62.2172104,67 C68.4820158,67 71.3359645,68.5303591 73.3210717,68.5303591 C73.8183692,68.5303591 75.8647198,68.298361 76.2378971,67 L77.6015865,67 L78.098884,76.7853499 L76.6723179,76.7853499 C74.9966948,73.4462339 71.7703853,68.854328 63.086052,68.854328 C57.1911576,68.854328 48.0724035,71.7766759 48.0724035,83.5091531 C48.0724035,91.9033427 54.5250224,97.145672 64.1394408,97.145672 C68.3578956,97.145672 72.6400436,96.0776521 72.6400436,94.4089226 L72.6400436,86.8946687 C72.6400436,83.0459853 71.3988412,82.9995857 67.1803865,82.766759 L67.1803865,81.9323943 L83,81.9323943 L83,82.766759 Z","id":"Fill-3","fill":"#00713B"}}),_c('g',{attrs:{"id":"Group-7","transform":"translate(82.000000, 67.000000)"}},[_c('mask',{attrs:{"id":"mask-2","fill":"white"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_c('g',{attrs:{"id":"Clip-6"}}),_c('path',{attrs:{"d":"M70.5720431,19.5579897 L77.7926659,6.92865641 L85.0727856,19.5579897 L70.5720431,19.5579897 Z M12.212091,15.608041 L12.212091,4.3104 C12.212091,2.97706667 12.7773126,2.65542564 16.1041868,2.65542564 C18.679085,2.65542564 26.9020671,2.79491282 26.9020671,8.90116923 C26.9020671,15.4693744 17.4866659,15.5620923 12.212091,15.608041 L12.212091,15.608041 Z M136.093121,23.3692718 C132.515037,29.3844513 128.497337,29.5698872 119.081935,29.5698872 C113.869337,29.5698872 112.73972,29.5231179 112.73972,27.6868103 L112.73972,5.96373333 C112.73972,2.33542564 114.308953,2.01378462 118.57869,1.82916923 L118.57869,0.95614359 L100.874199,0.95614359 L100.874199,1.82916923 C104.829923,2.05891282 106.337181,2.33542564 106.337181,5.96373333 L106.337181,26.3551179 C106.337181,29.8144 104.946438,30.2845538 101.123756,30.4740923 C98.5290251,30.3206564 97.6407018,29.7577846 95.6839114,26.4937846 L80.0510731,0.407220513 L78.7958515,0.407220513 L65.7379114,22.9565538 C64.5454922,24.9750154 62.5994443,28.3292718 61.1541629,29.4763487 C60.0418994,30.3362462 58.9924383,30.4388103 58.0016479,30.4855795 C53.4344263,30.388759 51.9478275,29.9112205 51.9478275,26.3551179 L51.9478275,5.96373333 C51.9478275,2.29029744 53.5162347,1.96701538 58.0999832,1.82916923 L58.0999832,0.95614359 L39.4542826,0.95614359 L39.4542826,1.82916923 C44.6644024,2.01378462 45.5419832,2.56516923 45.5419832,5.96373333 L45.5419832,26.3551179 C45.5419832,29.4066051 44.8809054,30.2853744 40.4194563,30.4609641 C38.0676719,30.3058872 36.6298275,29.5091692 35.3159353,28.3292718 L22.3827737,16.7099897 C25.5848695,16.2505026 33.7458754,15.1493744 33.7458754,8.99306667 C33.7458754,1.92024615 23.387612,0.95614359 17.8006778,0.95614359 L0.473001198,0.95614359 L0.473001198,1.82916923 C4.86834251,2.15081026 5.80872575,2.56516923 5.80872575,5.96373333 L5.80872575,25.8505026 C5.80872575,29.2941949 5.55751617,30.2582974 0.473001198,30.4872205 L0.473001198,31.3618872 L17.8618275,31.3618872 L17.8618275,30.4872205 C12.840115,30.3050667 12.212091,29.4304 12.212091,26.3551179 L12.212091,17.3073231 L15.7273725,17.2154256 L30.6693844,31.3618872 L70.3836359,31.3618872 L70.3836359,30.4872205 C69.0639593,30.4872205 66.1147257,30.4872205 66.1147257,28.5590154 C66.1147257,28.0544 66.3014802,27.4102974 66.6163186,26.8137846 L69.5052287,21.4394256 L85.9520192,21.4394256 L88.5269174,25.8505026 C88.9037317,26.4937846 89.7209892,28.0068103 89.7209892,28.7436308 C89.7209892,30.4412718 87.6476838,30.4872205 85.3239952,30.4872205 L85.3239952,31.3618872 L134.648666,31.3618872 L137.662354,23.3692718 L136.093121,23.3692718 Z","id":"Fill-5","fill":"#00713B","mask":"url(#mask-2)"}})]),_c('path',{attrs:{"d":"M43,52.8906593 C62.4974505,51.4300896 100.541978,44.5975803 123.446303,44.0590054 C146.907205,43.5074332 149.430298,46.9500886 181.060628,49.0800183 C197.487452,50.1847874 216,49.3553983 216,49.3553983 C216,49.3553983 183.233497,55.3983227 161.135674,54.9791603 C139.314084,54.5656842 120.46611,51.9702892 103.437493,51.4552719 C78.0495364,50.6851828 43,53.4771617 43,53.4771617 L43,52.8906593 Z","id":"Fill-8","fill":"#00713B"}}),_c('path',{attrs:{"d":"M172.331568,13.1044584 L172.697532,11.6652887 L173.074958,13.1128063 L173.074958,13.9292262 L173.563728,13.9225479 L173.885482,13.0234843 L174.227703,13.9559394 L174.227703,17.8652386 L175.01694,17.8652386 L175.01694,18.7467718 L175.702201,18.7467718 L175.702201,19.8503578 L176.359626,19.8503578 L176.359626,19.227608 L176.745239,18.0839523 L177.164419,19.1908775 L177.164419,21.3454582 L178.292603,21.3295972 L179.869441,23.161116 L179.869441,27.2607462 L181.136806,27.2607462 L181.912944,28.3668367 L181.912944,29.4779358 L182.552357,29.4779358 C182.68417,29.3034657 182.882298,29.1941088 183.113993,29.1941088 C183.449664,29.1941088 183.720658,29.500475 183.795161,29.8168586 L185.39001,29.8168586 L185.39001,31.474742 L185.738781,31.474742 L187.905909,31.474742 L188.849883,31.474742 L188.849883,32.1793008 L191.172566,32.1793008 C192.280282,32.1793008 193.180046,33.0057381 193.278291,34.1026459 L193.654079,34.1026459 L193.844839,34.9399355 L194.666006,34.9399355 C194.666006,34.9399355 194.877234,35.2245973 195.173607,35.2245973 C195.231736,35.2245973 195.278402,35.2120755 195.327525,35.1987189 C195.331618,35.1962146 195.338987,35.1953798 195.345537,35.1920406 C195.590331,35.0526315 195.868693,34.9674834 196.169979,34.9674834 C196.671848,34.9674834 197.120502,35.1920406 197.432431,35.5451548 L198.176639,35.5451548 L198.58272,36.7238715 L202.709843,38.5203293 L203.284578,40.1414822 L203.984576,40.1414822 L203.984576,41.4420776 L204.561767,41.4420776 L204.561767,42.5097679 L205.259309,42.9572128 L209,44.98908 C209,44.98908 197.533951,45.1668893 184.801356,44.087512 C177.485354,43.465597 163.406798,40.1147691 149.31105,38.6313558 C138.644882,37.5102392 128,39.057931 128,39.057931 C128,39.057931 133.065365,36.8482545 134.719981,36.1912786 C138.567923,34.666126 138.994471,33.1960692 138.994471,33.1960692 L139.733767,31.7919604 L140.617975,31.7919604 L140.944641,31.0298015 L142.016334,31.0298015 L142.994694,27.8467655 L144.018082,27.8467655 C144.018082,27.8467655 144.438081,27.2782767 144.99808,27.2782767 C145.342757,27.2782767 145.586733,27.4544164 145.732463,27.592156 C145.731645,27.5746255 145.727551,27.5529211 145.727551,27.5328862 C145.727551,26.1671776 146.814799,25.057748 148.154211,25.057748 C148.880408,25.057748 149.525552,25.3899926 149.968475,25.905055 C150.170696,26.0778556 150.262392,26.2798736 150.262392,26.2798736 L150.262392,21.7762073 C150.262392,21.7762073 150.584964,21.2077186 151.0066,21.2077186 C151.615721,21.2077186 151.835955,21.5391283 151.835955,21.5391283 L155.385886,21.5783632 L155.805885,21.10504 L157.250091,21.10504 L157.250091,20.3929682 L157.574301,19.5356438 L158.320965,19.5356438 L158.64845,18.6816585 L159.951838,18.6816585 L159.951838,16.8768529 L160.745987,14.1646357 L164.933695,14.1646357 L164.933695,10.8647297 L164.63814,10.6526942 L166.195328,7.57066719 L166.195328,6.30513279 L166.210065,6.30513279 L166.382813,6.23334126 L166.382813,5.23577292 L166.87404,0 L167.36281,5.23577292 L167.36281,6.23334126 L167.536377,6.30513279 L167.552751,6.30513279 L167.552751,7.5756759 L169.110758,10.6526942 L168.812748,10.8647297 L168.812748,11.7320715 L170.522216,11.7320715 L171.417068,13.1044584 L172.331568,13.1044584 Z","id":"Fill-10","fill":"#EB6608"}}),_c('path',{attrs:{"d":"M19.1108395,120.021947 L19.0750413,120.063801 C18.2906635,120.976749 16.3623349,123.37291 15.3949886,125.886787 C14.913702,127.137186 14.8039209,128.609063 15.4538567,128.903788 C16.155501,129.222927 17.7441446,128.765145 19.4202949,127.274956 C20.089323,126.679404 20.7257351,126.013222 21.3112342,125.293851 L21.5546618,124.994766 L21.4568134,125.347912 C20.9365466,127.22787 20.9015439,128.737242 21.195089,128.915995 C21.6063703,129.164505 23.995302,128.347474 25.4693914,126.991567 C25.7565724,126.72649 25.9148799,126.545993 26,126.433509 C23.0828462,127.62287 22.9953396,127.499923 22.9301074,127.410111 C22.8147577,127.250541 22.7908922,126.744801 23.6460709,124.223949 C23.9213191,123.413021 24.2522534,122.616044 24.4932945,122.035315 C24.651602,121.652523 24.7772933,121.350822 24.8210467,121.202588 C24.8075229,121.077025 24.1647467,120.048106 23.8131291,120.001892 C23.7860816,119.997532 23.7240314,119.990556 23.6659588,120.110888 C23.6564126,120.128327 22.8433962,121.639443 21.9993547,123.7496 L21.9802624,123.774887 C20.4838985,125.109866 18.4656768,126.666324 17.4068462,126.504139 C17.3527512,126.495419 17.2755862,126.468388 17.2183092,126.385551 C17.0432958,126.131809 17.1427352,125.486555 17.4840112,124.660804 C17.6375456,124.290218 17.8316513,123.827205 18.0233704,123.368551 C18.370215,122.541927 18.7281968,121.686529 18.7997931,121.488593 C19.0750413,120.736087 19.1426601,120.18762 19.1108395,120.021947","id":"Fill-12","fill":"#636362"}}),_c('path',{attrs:{"d":"M38.9371891,109 C38.9345446,109.00673 38.8975218,109.026077 38.8384617,109.096737 C38.7917425,109.150573 34.1973956,114.370165 31.3995336,120.231585 C28.4906033,126.327698 27.4407439,129.574697 28.2799262,129.883414 C29.2160729,130.229143 30.8036436,129.807707 33.1299064,128.59555 C34.2000401,128.038681 35.3098411,126.953545 35.5205182,126.621274 C35.4050425,126.673428 35.2084693,126.767641 35.0030812,126.866902 C33.8165902,127.438912 31.6049217,128.503019 30.8503628,128.133736 C30.6105964,128.01681 30.5347879,127.777071 30.6220559,127.423771 C31.04341,125.732135 34.1418615,120.197097 35.9515688,117.048518 C37.688112,114.026959 38.3333656,111.913045 38.6083918,111.010447 C38.6612814,110.838844 38.7009487,110.708459 38.7335639,110.620134 C39.0350349,109.792402 39.0456128,109.084119 38.9371891,109","id":"Fill-14","fill":"#636362"}}),_c('path',{attrs:{"d":"M40.2342306,122.060115 L39.7068262,123.300201 C38.8715013,125.264889 37.4733974,128.55314 37.3544099,128.892206 C37.3447622,128.921465 37.3375265,128.95847 37.3568218,128.974821 C37.4251592,129.029037 37.7379036,129.009244 38.397159,128.77947 C39.1794219,128.505808 39.9375656,128.008397 41.295471,124.69519 C41.834131,123.381095 42.3108852,122.177153 42.7120662,121.117787 L42.7233218,121.087667 L42.7562846,121.074758 C43.4565425,120.799375 44.891629,120.279589 45.8419216,119.93622 C46.3709339,119.745173 46.7889984,119.592851 46.8444723,119.569616 C46.9272812,119.534332 47.0108941,119.428482 46.9988345,119.375987 C46.9899909,119.336401 46.9015542,119.327795 46.8637676,119.325213 C46.8203532,119.322631 46.7608594,119.316607 46.6852862,119.307141 C46.2712416,119.258088 45.3024577,119.144493 43.443679,119.466347 L43.309416,119.489583 L43.3496145,119.375126 C43.7532075,118.222819 44.0426367,117.284794 44.2347855,116.505975 C44.7621899,114.364869 44.5049195,113.065404 44.3200063,113 C44.3208103,113.002582 44.2934753,113.019793 44.2589046,113.095524 C44.2412173,113.13511 42.4186172,117.153126 41.1684438,119.95085 L41.1539723,119.983552 L41.1161857,119.993018 C38.102906,120.796793 36.9685042,121.119508 37.000663,121.319161 C37.0464893,121.597987 37.3801369,122.615185 37.7869457,122.838934 C37.8303601,122.850121 38.1342608,122.841515 40.0589651,122.125518 L40.2342306,122.060115 Z","id":"Fill-16","fill":"#636362"}}),_c('path',{attrs:{"d":"M48.8624969,120.075072 C48.1976018,120.922966 47.6047757,122.292709 46.8716861,124.090386 C46.0882258,126.01033 45.8332718,127.175409 46.1052744,127.847876 C46.3772769,128.520344 46.9081081,129.37444 47.1467884,128.823353 C47.3637705,128.322768 49.2817373,123.462218 49.4863204,123.003274 C49.6909036,122.545216 50.1016197,121.329636 49.976855,121.06561 C49.7730468,120.63679 49.1290749,119.734851 48.8624969,120.075072","id":"Fill-18","fill":"#636362"}}),_c('path',{attrs:{"d":"M54.1226775,119.8922 C53.9699988,119.997968 53.9191059,121.4463 54.2125884,124.367701 C54.5086155,127.33175 55.0675894,129.873581 55.3322326,129.998967 C55.5951794,130.048439 57.4332621,128.318629 59.4723718,125.269283 C61.5555887,122.151701 61.8617944,121.130703 61.895723,120.836431 C62.0068393,119.910965 62.0314375,119.166328 61.958491,119 C61.6302316,119.263566 60.2433995,121.123027 59.4469253,122.371766 C58.677594,123.577003 56.5850467,125.891094 56.5638413,125.914124 L56.4264304,126.066804 L56.4094661,125.874888 C56.4086179,125.857828 56.2559392,124.158725 55.6749116,122.480092 C55.0862502,120.778429 54.766473,120.245327 54.1226775,119.8922","id":"Fill-20","fill":"#636362"}}),_c('path',{attrs:{"d":"M76,128.932191 C76,128.932191 76.0434641,128.988317 76.3640666,128.998451 C76.9916119,129.018719 77.9381526,128.837088 78.0643044,128.631292 L78.0643044,128.630513 C78.3439277,128.176826 78.6074806,127.509548 79.1313724,126.17889 L79.2261872,125.938795 C80.099608,124.212135 80.6556404,123.316455 81.9846543,122.540822 C82.8942333,122.009962 84.0312071,121.967868 84.8620416,121.937466 C85.2003215,121.924994 85.4936044,121.91408 85.655111,121.868867 C86.110704,121.742584 87.0516201,120.793895 86.9977846,120.515603 C86.993767,120.495335 86.9865354,120.456359 86.8748468,120.456359 L86.750302,120.45402 C85.9612502,120.442327 83.5507051,120.397894 80.7488482,122.165089 L80.5752889,122.274223 L80.6186787,122.098049 C80.7247427,121.668528 80.7978626,121.273306 80.8195575,121.011384 C80.8436629,120.722179 80.4836882,120.33865 80.1325521,120.125058 C79.9308699,120.001113 79.8352516,119.996436 79.8199848,120.001113 L79.7958793,120.05646 C79.5130421,120.622399 78.9875432,121.675544 77.8457484,124.537199 C77.2173996,126.113409 76.7360941,127.186043 76.4170986,127.895416 C76.1551527,128.480063 75.9960568,128.831631 76,128.932191","id":"Fill-22","fill":"#636362"}}),_c('path',{attrs:{"d":"M147.740796,120 C147.736866,120 147.733722,120.000787 147.731364,120.000787 L147.707783,120.057425 C147.431886,120.623024 146.917821,121.675556 145.802443,124.536587 C145.190124,126.109092 144.719292,127.182077 144.408023,127.890845 C144.150991,128.476896 143.996143,128.8301 144,128.930791 C144.003217,128.941017 144.060597,128.980349 144.275184,128.994509 C144.865494,129.034628 145.887334,128.84898 146.019387,128.631079 C146.263057,128.225169 146.48629,127.669797 146.939044,126.496908 C147.908221,124.567266 148.772069,123.211875 150.095746,122.40635 C150.984747,121.864351 152.096981,121.822659 152.910524,121.791979 C153.241443,121.779393 153.527558,121.769167 153.685551,121.722754 C154.134374,121.592958 155.054817,120.62145 154.997437,120.336684 C154.993507,120.315445 154.985646,120.276113 154.878746,120.275326 L154.757697,120.273753 C153.944155,120.26038 151.481519,120.210821 148.637658,122.186089 L148.462373,122.307232 L148.507176,122.121584 C148.614863,121.681849 148.687964,121.277513 148.709186,121.013987 C148.731981,120.718994 148.375123,120.332751 148.026911,120.118784 C147.862631,120.018093 147.771451,120 147.740796,120","id":"Fill-24","fill":"#636362"}}),_c('path',{attrs:{"d":"M65.723436,128.77702 C68.8156674,129.775014 73.2472788,127.121597 73.8553253,126.743102 C73.8184232,126.748633 73.7597153,126.762856 73.6716533,126.794464 C73.2103766,126.958821 69.0555313,127.599655 67.5878326,127.208517 C66.4849619,126.914571 66.0245239,126.256353 66.2199375,125.252827 C66.2870323,124.91305 66.5336056,124.020149 67.3957738,123.066405 C68.1229136,122.262794 69.1192714,121.594304 70.2766566,121.13284 C71.8751902,120.496747 72.3004034,120.612113 72.5553637,120.682439 C72.7130364,120.725108 72.8245815,120.846796 72.860645,121.003251 C72.9118048,121.226081 72.8715479,121.84637 71.4122361,122.813548 C70.4427162,123.455172 68.6982515,123.562637 68.2000727,123.463074 C68.13801,123.451221 68.0826568,123.438579 68.0306583,123.427516 C67.7287317,123.361141 67.6574435,123.345338 67.4704167,123.593453 C67.2188112,123.93165 67.1005567,124.42156 67.2230047,124.621475 C67.2682937,124.694171 67.6398311,124.883024 68.2981988,124.991278 C68.9800497,125.102693 70.7454815,125.240184 72.4060777,124.090475 C73.9006143,123.055342 74.2184759,121.779996 73.8729377,120.976385 C73.6179775,120.386122 73.0090922,120.031332 72.2005999,120.002886 C71.0021191,119.958636 67.4167409,120.400345 65.3569306,122.928124 C64.1265798,124.438944 63.7063986,126.039054 64.2054162,127.315981 C64.4821822,128.0224 65.0357143,128.55498 65.723436,128.77702","id":"Fill-26","fill":"#636362"}}),_c('line',{attrs:{"x1":"100.5","y1":"128.5015","x2":"100.5","y2":"128.4985","id":"Fill-28","fill":"#636362"}}),_c('path',{attrs:{"d":"M104.321966,122.340735 C104.399805,122.577286 103.575942,126.69247 103.549705,127.276229 C103.511223,128.098143 103.624045,128.960151 104.108567,128.923265 C104.593963,128.887181 105.366225,128.613744 105.521027,128.395636 C105.674955,128.176726 107.143389,122.695161 106.988587,121.693628 C106.834659,120.692096 105.468552,120.418659 104.69629,120.72818 C103.923154,121.037701 103.176255,121.292695 101.965825,122.258143 C101.564389,122.578088 101.011649,123.056001 100.439668,123.573206 C101.380725,121.196471 100.69942,120.10994 100.625955,120.057819 C100.55249,120.005697 100.488645,119.959189 100.430047,120.057819 C100.430047,120.057819 98.5138237,123.235619 97.4083438,125.423916 C96.3037385,127.61141 95.9355367,128.288186 96.0090021,128.44455 C96.0824676,128.600914 96.8932111,129.226371 97.4083438,128.913642 C97.4581953,128.883172 97.5176674,128.831852 97.5850107,128.76209 C98.0642852,128.220829 102.411865,123.395993 102.919126,123.004682 C103.48586,122.567664 104.245002,122.104184 104.321966,122.340735","id":"Fill-30","fill":"#636362"}}),_c('path',{attrs:{"d":"M188.093757,120 C188.091333,120.003256 188.089717,120.006513 188.087292,120.009769 C188.069513,120.043148 186.306168,123.260532 185.298427,125.453759 L184.906483,126.303696 C184.252703,127.718628 183.955311,128.365036 184.005415,128.48064 C184.045013,128.572635 184.411097,128.905609 184.774757,128.983764 C184.929918,129.017142 185.05922,128.999232 185.166701,128.928404 C185.19337,128.909679 185.241049,128.870602 185.31459,128.786748 L185.488338,128.587289 C186.383749,127.484977 189.816696,123.302052 190.250663,122.934072 C190.479364,122.740313 191.251131,122.115886 191.559837,122.179387 C191.625296,122.192413 191.67136,122.23149 191.689139,122.288478 C191.727929,122.422807 191.571151,123.426612 191.3077,125.062984 C191.142841,126.087141 190.98768,127.055124 190.976366,127.315641 C190.942424,128.141154 191.051522,128.728131 191.268102,128.885256 C191.310124,128.914564 191.352956,128.925961 191.40306,128.922705 C191.845916,128.88607 192.518283,128.614155 192.642735,128.42121 C192.775269,128.211168 194.129699,122.640176 193.989892,121.652654 C193.930898,121.2285 193.658557,120.899598 193.22459,120.727005 C192.827797,120.569067 192.345342,120.567438 191.995421,120.721306 L191.826521,120.794577 C191.18244,121.075446 190.514922,121.366086 189.492635,122.261613 C189.131399,122.577489 188.632782,123.05049 188.085676,123.59432 L187.82869,123.849952 L187.941828,123.537332 C188.825925,121.084402 188.139013,120.035821 188.130931,120.02768 C188.120426,120.019539 188.105879,120.008955 188.093757,120","id":"Fill-32","fill":"#636362"}}),_c('path',{attrs:{"d":"M117.159384,124.244145 C115.924769,126.580764 113.82398,127.778645 112.571619,127.543734 C111.814456,127.402954 111.784034,126.349184 112.473593,124.126689 C112.992453,122.453986 115.518301,120.169848 117.194876,120.69465 C117.567542,120.810439 118.592585,121.5335 117.159384,124.244145 M119.264398,120.51805 C117.754298,119.494269 115.49464,120.223994 114.44171,120.697149 C113.856937,121.0037 112.111068,122.077462 111.183205,123.311163 C110.185204,124.638996 109.816763,125.987654 110.084643,127.318819 C110.21647,127.972739 110.8342,128.529196 111.735866,128.808257 C113.049071,129.213937 114.684239,128.967364 116.113215,128.149339 C118.838494,126.589094 119.90579,124.165841 119.993675,122.564778 C120.045223,121.61347 119.779878,120.867085 119.264398,120.51805","id":"Fill-34","fill":"#636362"}}),_c('path',{attrs:{"d":"M123.287585,127.428105 C122.793398,127.428105 122.163074,128.475694 122.007264,128.874817 C121.9931,128.908582 122.003329,128.918971 122.007264,128.9233 C122.137106,129.064422 123.251386,128.991696 125.274561,128.859233 C125.626314,128.836723 126.008758,128.812481 126.4274,128.784776 C128.233384,128.670494 129.294154,128.348425 129.670302,127.800389 C129.928412,127.424642 129.875688,126.938941 129.505836,126.270562 C129.285498,125.874037 128.696881,125.333793 128.073639,124.760649 C127.007361,123.779724 125.904884,122.766766 126.166929,122.094924 C126.615474,120.9521 130.272297,121.589311 130.308495,121.596237 C130.332103,121.600566 130.39427,121.576324 130.491848,121.459445 C130.802682,121.083698 131.081252,120.241298 130.978165,120.110565 C130.816059,119.940008 128.174365,119.894987 126.633573,120.513151 C125.134489,121.112268 124.818146,122.401409 124.587578,123.341642 C124.430981,123.980585 125.464996,124.796146 126.377037,125.516471 C127.093922,126.082689 127.712442,126.570987 127.768314,126.954525 C127.773822,126.988291 127.768314,127.038506 127.71559,127.088721 C127.45748,127.333735 126.105549,127.446286 123.47015,127.428971 L123.287585,127.428105 Z","id":"Fill-36","fill":"#636362"}}),_c('path',{attrs:{"d":"M175.114189,120 C174.444747,120 172.880873,120.593475 171.530148,121.382806 C170.018377,122.264999 168.139519,123.950029 167.472445,125.461998 C167.005099,126.521474 166.773004,127.895838 167.307453,128.576266 C167.507969,128.831215 167.805587,128.972197 168.191621,128.994991 C169.624448,129.079411 171.776452,128.092537 173.944244,126.353477 C175.487592,125.115875 175.930466,124.565454 176,124.398302 C175.733896,124.48441 174.83157,124.892161 173.629259,125.433295 L172.917977,125.754937 C170.934913,126.646416 169.331567,127.016177 169.085263,126.979032 C169.042634,126.973123 168.983426,126.945264 168.942375,126.850713 C168.816065,126.560307 168.846064,125.453556 170.480987,123.851257 C171.798556,122.56047 172.944818,121.95602 174.368171,121.400534 C174.697366,121.316958 175.564167,121.085646 175.755211,120.973367 C175.93836,120.866153 176.019672,120.739522 175.995989,120.59854 C175.954149,120.345279 175.606797,120.112279 175.302074,120.021949 C175.25155,120.006754 175.187606,120 175.114189,120","id":"Fill-38","fill":"#636362"}}),_c('path',{attrs:{"d":"M182.053049,118.952182 C182.442169,118.681936 183.021556,117.366033 182.999382,117.121398 C182.977923,116.87588 181.930019,115.705697 181.688249,116.069558 C181.525878,116.314193 181.16537,117.017186 181.01802,117.652175 C180.870669,118.287165 181.66393,119.222428 182.053049,118.952182","id":"Fill-40","fill":"#636362"}}),_c('path',{attrs:{"d":"M180.810678,120 C180.808021,120 180.80625,120 180.803594,120.00081 C180.784998,120.044551 180.710613,120.189544 180.593723,120.416348 C179.964996,121.637851 178.053136,125.35582 177.295122,126.932919 C177.272984,126.98071 177.246418,127.030931 177.21631,127.084392 C177.068426,127.354937 176.88335,127.692714 177.096763,128.109871 C177.485511,128.875336 177.656418,129.017088 177.75117,128.998458 C177.947758,128.906116 179.569164,126.845438 180.605235,124.679457 C181.371219,123.080487 182.170853,121.347865 181.968066,121.031149 C181.806014,120.777615 181.01435,120 180.810678,120","id":"Fill-42","fill":"#636362"}}),_c('path',{attrs:{"d":"M209.047917,127.632351 C208.914247,127.635782 208.813591,127.645219 208.791044,127.670098 C208.74273,127.723287 208.645295,127.795349 208.509209,127.89658 C208.278909,128.0673 207.962449,128.301503 207.775632,128.539138 C207.823947,128.795646 210.869378,129.005828 212.784247,128.893445 C214.371382,128.799935 215.623536,127.71814 215.576026,126.481067 C215.545427,125.699531 215.129116,124.290881 214.824734,123.262274 C214.676569,122.7647 214.550146,122.334041 214.503442,122.099837 L214.496195,122.063806 L214.718442,121.858771 C215.135558,121.474438 215.344116,121.282271 215.600989,120.884211 C215.907787,120.403795 216.139697,119.260231 215.90215,119.104954 C215.642056,118.934234 214.887543,118.970265 214.602487,119.2242 C214.306963,119.486713 214.044453,120.094955 213.711888,120.865338 C213.380127,121.634005 212.855108,122.310878 212.482281,122.639448 C211.705221,123.325758 205.478272,126.706691 200.822354,127.164802 L200.799808,127.167376 C200.099246,127.236865 199.374526,127.307212 198.985594,126.949473 C198.733553,126.716985 198.658665,126.336084 198.755294,125.78532 C199.176437,123.402968 202.012504,121.252245 202.942561,120.779549 C204.335632,120.070077 204.71007,120.188465 204.934733,120.25967 C205.069209,120.301706 205.164227,120.420094 205.199658,120.579661 C205.251194,120.813865 205.234284,121.477011 203.952336,122.547654 C203.045632,123.304311 201.514059,123.378089 201.148478,123.297448 C201.095332,123.285437 201.046212,123.273427 201.001924,123.261416 C200.74183,123.196217 200.686268,123.181633 200.527635,123.445862 C200.309414,123.81218 200.208759,124.340638 200.316661,124.55511 C200.36095,124.640899 200.723309,124.851939 201.359452,124.948022 C202.076924,125.056116 203.474021,125.063837 204.805894,123.902258 C206.157898,122.722663 206.388198,121.285703 206.029059,120.448405 C205.78507,119.877052 205.282598,119.553629 204.615857,119.536471 C204.590089,119.536471 200.569508,119.640275 198.356699,123.006624 C197.095687,124.924859 196.668103,126.931457 197.267204,128.121347 C197.495893,128.574311 197.861474,128.856556 198.323684,128.933766 C200.407654,129.282068 203.304115,128.177109 205.374396,127.473642 C208.804733,126.307773 212.753648,123.604571 213.060446,123.342916 L213.157075,123.259701 L213.194921,123.372084 C213.315708,123.737544 213.615258,124.658914 213.764228,125.319487 C213.975202,126.250295 213.907562,126.774464 213.532318,127.126198 C213.120839,127.513105 211.700389,127.626346 210.581101,127.653798 C210.573048,127.653798 210.56258,127.654656 210.553722,127.654656 C210.197805,127.662377 209.872486,127.651224 209.583404,127.641788 C209.405445,127.635782 209.204134,127.628919 209.047917,127.632351","id":"Fill-44","fill":"#636362"}}),_c('path',{attrs:{"d":"M216,131.988218 C216.191933,132.066375 217.37331,131.744552 218.025219,131.352848 C219.11063,130.700009 219.996664,129.717071 220,129.160778 C220.004937,128.586095 219.329036,128.085891 219.237207,128.05187 L219.196669,128.036238 C219.102357,127.995781 218.985709,127.947047 218.677955,128.148416 C218.345382,128.365417 217.686028,129.147905 217.023364,130.35336 C216.682519,130.975856 216.39462,131.393306 216.203515,131.670073 C216.11003,131.806158 216.020682,131.935807 216,131.988218","id":"Fill-46","fill":"#636362"}}),_c('path',{attrs:{"d":"M10.6231942,113.029469 L10.6231942,113.030286 L10.5830391,113.048263 C9.00527614,113.813915 7.54714209,114.705404 6.24962866,115.699035 C2.57375889,118.514051 -0.79760096,123.511622 0.166959314,126.677187 C0.514970654,127.822804 1.18673293,128.553319 2.16133199,128.84912 C3.48477896,129.250332 5.42561143,128.847486 7.77803423,127.68716 C11.033948,126.07823 13.9025319,122.576008 14.7047984,121.540703 L14.7641946,121.46471 C14.7892915,121.433659 14.8143885,121.400974 14.8361392,121.372374 C14.8026766,121.391985 14.763358,121.414865 14.7232028,121.438562 L14.5525434,121.539886 C14.1535016,121.774402 13.5143654,122.138026 11.8094444,123.054029 C10.5294989,123.741236 4.07372122,127.115169 2.67414678,126.048813 C2.1855924,125.676202 2.51352616,122.51554 6.84860972,117.894666 C8.04071587,116.62321 9.5381685,115.400783 11.2991393,114.263337 C11.9198711,113.947924 12.5397663,113.716676 13.1496227,113.572861 C14.0405652,113.361224 14.5425046,113.391458 14.9089204,113.411886 C15.0678679,113.420875 15.2067378,113.429863 15.3439346,113.415972 C15.7454861,113.375933 17.9088451,111.732683 17.9958479,111.289798 C18.0083964,111.22361 17.9925017,111.172131 17.9481637,111.132092 C17.8686899,111.061818 17.6955208,111.023413 17.4462242,111.020145 L17.417781,111.020145 L17.3951937,111.006254 C17.3935206,111.006254 17.3592214,110.993997 17.207803,111.003802 C15.4970261,111.1182 12.9747805,111.893658 10.6231942,113.029469","id":"Fill-48","fill":"#636362"}}),_c('path',{attrs:{"d":"M156.079488,127.650059 C155.809941,127.626859 155.47876,127.567658 155.305363,127.312457 C155.042391,126.929254 155.223184,126.20845 155.856783,125.109244 C156.474768,124.036437 157.49132,123.044431 158.719893,122.317227 C159.798079,121.678023 160.910781,121.319621 161.693945,121.349221 C161.780233,121.352421 161.855016,121.386821 161.906788,121.446822 C162.159899,121.738023 161.864877,122.625229 161.803243,122.80043 C161.676688,123.162032 161.283051,124.102038 160.944474,124.902842 C160.545085,125.722847 156.95387,127.726059 156.079488,127.650059 M163.868397,120.818818 C163.767317,120.612417 163.221649,120.086813 162.979222,120.030813 C162.740903,119.976413 161.689836,119.935613 160.033933,120.445216 C158.525951,120.909218 155.141827,122.594829 153.766975,124.56844 C152.496491,126.394051 152.983811,128.383663 153.932155,128.834066 C154.911726,129.299669 157.370517,128.897266 160.406203,126.17645 C160.312519,126.401251 160.125151,126.757253 159.9271,127.133256 C159.686316,127.590858 159.32966,128.266863 159.311581,128.444464 C159.637831,128.422063 160.891058,128.214862 161.133485,128.074861 L161.191832,128.043661 C161.453161,127.90286 161.811461,127.709259 162.791854,125.423645 C163.897981,122.84603 164.210261,121.510822 163.868397,120.818818","id":"Fill-50","fill":"#636362"}}),_c('path',{attrs:{"d":"M52.0142261,115 C51.9739672,115 51.9558507,115.020991 51.946457,115.031943 C51.7686467,115.234552 51.2956044,115.901703 51.04667,116.556077 C50.899725,116.943956 51.121149,117.541745 51.4130262,117.83562 C51.49757,117.920497 51.6606186,118.053745 51.8089056,117.977081 C52.2168627,117.767171 52.9864791,116.506794 52.9998988,116.274067 C53.0086215,116.09975 52.4517064,115.185269 52.0967569,115.021904 C52.0625368,115.005476 52.0350266,115 52.0142261,115","id":"Fill-52","fill":"#636362"}}),_c('path',{attrs:{"d":"M119.186423,138.021454 L119.147536,138.066316 C118.348736,138.980682 116.384953,141.378752 115.402251,143.886937 C114.912115,145.13899 114.800316,146.609643 115.462202,146.9041 C116.176747,147.222211 117.7946,146.766252 119.501568,145.276023 C120.182087,144.680584 120.830201,144.014181 121.427275,143.29476 L121.675989,142.996225 L121.576341,143.348595 C121.045698,145.228714 121.010052,146.737703 121.309804,146.916335 C121.616848,147.100676 122.567955,146.739335 123.850409,145.947319 C124.278974,145.683042 124.644348,145.371456 124.845263,145.183036 C123.426705,145.557429 123.154497,145.51583 123.075913,145.411424 C122.958443,145.251553 122.934949,144.745837 123.805041,142.223786 C124.08454,141.415457 124.420749,140.62181 124.665411,140.041868 C124.82582,139.661766 124.953012,139.360784 125,139.209069 C124.975696,139.05817 124.329203,138.04674 123.975171,138.001878 C123.949246,137.997799 123.884435,137.989643 123.825295,138.110362 C123.815573,138.128307 122.988418,139.639743 122.128048,141.749881 L122.109414,141.775983 C120.585538,143.109603 118.54236,144.66427 117.451099,144.503583 C117.39601,144.495427 117.318236,144.469325 117.259906,144.385311 C117.081675,144.132453 117.182132,143.487258 117.530493,142.660985 C117.690901,142.280067 117.895867,141.801269 118.095972,141.328996 C118.456485,140.483962 118.797555,139.683789 118.870468,139.488844 C119.149967,138.735165 119.218829,138.187035 119.186423,138.021454","id":"Fill-54","fill":"#636362"}}),_c('path',{attrs:{"d":"M180.07748,145.552881 C179.943252,145.552881 179.840317,145.522943 179.770321,145.4639 C179.745616,145.442279 179.721735,145.405689 179.724206,145.281781 C179.730794,144.720455 180.243824,142.717975 182.43923,140.940026 C184.25748,139.466441 185.727398,139.172056 186.442181,139.12715 L186.571468,139.119666 L186.527,139.221952 C186.079849,140.268929 185.64999,141.281812 185.323068,142.171618 L185.303304,142.199892 C185.016732,142.446044 184.709573,142.717975 184.390885,143.009865 C182.666511,144.586568 180.851554,145.540407 180.092303,145.552881 L180.07748,145.552881 Z M191.190385,144.259751 L191.203561,144.411933 C191.300732,145.549554 191.940578,146.452666 192.874408,146.769503 C195.909767,147.800681 200.261051,145.060577 200.858077,144.669727 C200.821843,144.675549 200.765023,144.689686 200.677734,144.722118 C200.276698,144.872636 195.677544,145.916288 194.174688,145.495501 C193.25321,145.236875 192.746768,144.242288 192.974873,143.018181 C193.089337,142.402801 193.513431,141.421519 194.330326,140.682232 C196.869124,138.384536 199.335456,138.341293 199.594853,138.415305 C199.736493,138.456053 199.846016,138.581624 199.882249,138.743785 C199.931658,138.972474 199.892131,139.613633 198.458447,140.612378 C197.508971,141.274327 195.795302,141.384929 195.30533,141.283475 C195.244392,141.271832 195.190042,141.257695 195.138986,141.246885 C194.843356,141.177862 194.771713,141.16123 194.589723,141.418193 C194.341855,141.766631 194.225744,142.272241 194.346796,142.479308 C194.39044,142.554983 194.755243,142.749576 195.402501,142.861009 C196.071993,142.976601 197.807072,143.116309 199.435098,141.931287 C200.901721,140.861856 201.215468,139.545442 200.874546,138.714679 C200.625854,138.105952 200.027182,137.740051 199.233344,137.710945 C198.05494,137.664376 194.535373,138.120921 192.513722,140.730464 C191.750353,141.716735 191.297438,142.753734 191.203561,143.729194 L191.200267,143.768279 L191.158269,143.786574 C190.433604,144.095927 186.599466,145.298413 186.183607,144.967438 C186.135022,144.929185 186.113611,144.876794 186.130905,144.79613 C186.17949,144.586568 187.548119,141.033996 188.963686,138.237344 C190.338903,135.514704 191.390491,133.408275 191.390491,133.080627 C191.390491,132.913476 190.995219,132.477721 190.577713,132.182505 C190.351256,132.02367 190.238438,131.996228 190.220322,132.000386 C190.087741,132.121798 188.473714,134.815333 187.092733,137.915517 L187.068028,137.971234 L186.999679,137.960423 C186.826748,137.934644 186.666169,137.916349 186.495708,137.90637 C185.227544,137.825705 184.071373,138.02113 182.187244,139.239415 C180.419226,140.383689 178.259229,142.308831 178.013831,144.985733 C177.932307,145.889676 178.212291,146.518362 178.824139,146.803599 C179.704442,147.213575 181.256708,146.8826 182.683804,145.981152 C183.252831,145.621903 183.858915,145.166189 184.483938,144.628148 L184.658517,144.478461 L184.627224,144.686359 C184.581109,145.008186 184.558875,145.295918 184.558875,145.566186 C184.558875,146.274705 184.716161,146.702144 185.026614,146.837694 C185.35436,146.98156 186.445475,146.664723 186.810278,146.499235 C187.535767,146.170755 189.964218,145.269307 191.061921,144.366195 L191.190385,144.259751 Z","id":"Fill-56","fill":"#636362"}}),_c('path',{attrs:{"d":"M170.094132,137 C170.091708,137.003427 170.090092,137.007712 170.087668,137.011996 C170.06989,137.047984 168.306657,140.622758 167.298172,143.060494 L166.90706,144.003029 C166.254131,145.576204 165.955949,146.294243 166.005242,146.421914 C166.045646,146.525593 166.411707,146.894895 166.776151,146.982293 C166.929687,147.019138 167.059788,146.998573 167.167263,146.919743 C167.205242,146.891467 167.256152,146.8392 167.315141,146.76294 L167.488879,146.54273 C168.367263,145.339713 171.812113,140.673313 172.250901,140.260311 C172.47878,140.046099 173.243225,139.348624 173.560801,139.420599 C173.625447,139.436022 173.671508,139.479722 173.688477,139.543128 C173.728073,139.69222 173.571306,140.806981 173.307871,142.626072 C173.143023,143.763968 172.987871,144.838457 172.976558,145.128929 C172.942618,146.045757 173.051709,146.697819 173.268275,146.87176 C173.310295,146.905177 173.353932,146.91803 173.403225,146.914602 C173.846053,146.873474 174.517569,146.571863 174.642821,146.35765 C174.775347,146.12373 176.12969,139.934709 175.989892,138.836228 C175.930903,138.364961 175.658579,137.999943 175.22464,137.808009 C174.82868,137.633212 174.346255,137.630641 173.99474,137.802011 L173.826659,137.883412 C173.182619,138.195305 172.515144,138.518337 171.492921,139.513139 C171.130901,139.865304 170.630698,140.391409 170.085244,140.993774 L169.829082,141.277391 L169.942213,140.930367 C170.826254,138.205587 170.139385,137.039415 170.131304,137.030847 C170.120799,137.021421 170.106254,137.009425 170.094132,137","id":"Fill-58","fill":"#636362"}}),_c('g',{attrs:{"id":"Group-62","transform":"translate(136.000000, 137.000000)"}},[_c('mask',{attrs:{"id":"mask-4","fill":"white"}},[_c('use',{attrs:{"xlink:href":"#path-3"}})]),_c('g',{attrs:{"id":"Clip-61"}}),_c('path',{attrs:{"d":"M13.1500632,0.966164706 C13.2073263,0.966164706 13.2906947,0.981811765 13.3622737,1.05345882 C13.7201684,1.42157647 13.5450105,3.15263529 11.9837474,6.91451765 C10.5589053,10.3404 9.21237895,13.5809882 9.20732632,14.0001647 C9.49027368,13.9828706 10.1917474,13.8395765 10.8688,13.3191059 C11.6418526,12.7245176 13.6502737,9.12569412 14.9235368,6.05228235 C16.0949053,3.22510588 15.8768,1.04851765 15.4995368,0.510752941 C15.4321684,0.415223529 15.3782737,0.394635294 15.3580632,0.390517647 C14.8250105,0.267811765 13.1795368,0.181341176 12.9521684,0.243929412 C12.7290105,0.304870588 11.8683789,0.719105882 11.2477474,1.29063529 C10.9066947,1.60275294 10.6321684,1.87122353 10.4730105,2.04251765 L10.2018526,2.33487059 L10.3197474,1.98898824 C10.4216421,1.69169412 10.4317474,1.29228235 10.2852211,1.17122353 C10.0426947,0.971929412 9.00185263,0.399576471 8.36522105,0.536282353 C7.67385263,0.682870588 7.16858947,0.950517647 6.01658947,1.77981176 C5.19553684,2.37192941 3.9568,3.67310588 3.94501053,3.68545882 L3.50037895,4.15404706 L3.79595789,3.62287059 C3.86922105,3.49110588 4.46458947,1.74851765 4.50922105,1.2684 C4.52101053,1.14157647 4.12185263,0.901105882 3.73364211,0.801458824 C3.36648421,0.706752941 3.13911579,0.840164706 3.05658947,0.981811765 C3.01953684,1.0444 2.15048421,2.54487059 1.39595789,5.13569412 C1.19890526,5.81098824 1.02037895,6.41875294 0.863747368,6.94910588 C0.482273684,8.24287059 0.206063158,9.17757647 0.222905263,9.27722353 C0.266694737,9.36698824 1.02627368,9.74498824 1.54248421,9.81169412 C1.71343158,9.83310588 1.85153684,9.78945882 2.00058947,9.49628235 C2.04269474,9.4164 2.10501053,9.25663529 2.19258947,9.0384 C2.51090526,8.23463529 3.10458947,6.73910588 4.13869474,5.20075294 C5.39848421,3.32969412 7.29237895,1.64887059 7.65364211,1.64887059 C7.68816842,1.64887059 7.73785263,1.65792941 7.78164211,1.69992941 C8.02837895,1.93875294 7.82964211,3.26463529 7.32016842,4.78322353 C6.98922105,5.76981176 6.64143158,6.59581176 6.38711579,7.19863529 C6.15722105,7.74710588 5.9568,8.22228235 6.00311579,8.29887059 C6.1168,8.49569412 6.48648421,8.80863529 7.18122105,9.10345882 C7.28816842,9.14875294 7.35637895,9.16110588 7.41195789,9.14710588 C7.47174737,9.13145882 7.5248,9.07957647 7.57111579,8.99310588 C7.72437895,8.70487059 8.02248421,8.09957647 8.36690526,7.39875294 C8.82922105,6.45992941 9.35132632,5.39592941 9.73869474,4.66545882 C10.3980632,3.42357647 12.5816421,0.966164706 13.1500632,0.966164706","id":"Fill-60","fill":"#636362","mask":"url(#mask-4)"}})]),_c('path',{attrs:{"d":"M104.079144,145.650396 C103.809597,145.627196 103.478416,145.567194 103.305019,145.312786 C103.042047,144.929574 103.22284,144.208752 103.856439,143.109518 C104.474424,142.035885 105.490977,141.044654 106.719551,140.317431 C107.797737,139.678212 108.910439,139.319801 109.694425,139.349401 C109.779891,139.352602 109.854674,139.387003 109.906447,139.447004 C110.159558,139.737413 109.864535,140.625441 109.802901,140.800646 C109.676346,141.162258 109.282709,142.101487 108.944132,142.902311 C108.544743,143.723137 104.953527,145.726399 104.079144,145.650396 M111.868878,138.818985 C111.766154,138.612579 111.221308,138.086962 110.978881,138.030961 C110.740562,137.976559 109.689494,137.934958 108.033591,138.445374 C106.52643,138.909388 103.140661,140.59504 101.766631,142.567901 C100.496968,144.394358 100.983466,146.384019 101.93181,146.833633 C102.911382,147.300047 105.369352,146.897635 108.405861,144.176751 C108.312999,144.400758 108.124809,144.756769 107.926758,145.13358 C107.685974,145.591195 107.329318,146.267216 107.311238,146.444821 C107.637488,146.42242 108.889894,146.215214 109.133144,146.07521 L109.191491,146.044009 C109.452819,145.902404 109.811119,145.709598 110.791513,143.423928 C111.89764,140.846248 112.20992,139.511006 111.868878,138.818985","id":"Fill-63","fill":"#636362"}}),_c('path',{attrs:{"d":"M17.2828272,145.426966 C16.7796423,145.433191 16.1584858,146.478066 16.0068081,146.874075 C15.99156,146.914532 16.0060055,146.926981 16.0108207,146.932427 C16.1584858,147.067023 17.2868399,146.983776 19.3356933,146.829729 C19.6944232,146.803276 20.0852542,146.772933 20.5113965,146.741813 C22.3066511,146.610328 23.372408,146.291342 23.7696593,145.768515 C24.0585693,145.38651 24.0047999,144.890914 23.5979183,144.21015 C23.3659878,143.819586 22.7536591,143.290535 22.1060192,142.730364 C21.0009384,141.774961 19.8573363,140.786881 20.1101326,140.124012 C20.5426951,138.988887 24.2880922,139.576289 24.3250085,139.583291 C24.3442692,139.582513 24.3908158,139.570843 24.4670559,139.488373 C24.7888695,139.149158 25.0914225,138.236546 24.9742535,138.095725 C24.8177605,137.928452 22.0883636,137.92534 20.5555355,138.543862 C19.0395605,139.155382 18.7426253,140.435996 18.5259428,141.370393 C18.3774751,142.009144 19.4496522,142.80661 20.396635,143.50838 C21.1373681,144.059215 21.7769828,144.53536 21.8427901,144.911142 C21.8476052,144.945375 21.8427901,144.995168 21.7842055,145.046517 C21.5089385,145.286924 20.1414312,145.407516 17.4690137,145.42541 L17.2828272,145.426966 Z","id":"Fill-65","fill":"#636362"}}),_c('path',{attrs:{"d":"M26,138.995249 C26.203479,139.039139 27.1920797,138.772284 27.6921389,138.470317 C28.5156529,137.972598 29.1059339,137.21768 28.9840384,136.821786 C28.8563842,136.41097 28.1096547,136.053701 28.0184731,136.031756 L27.979121,136.021222 C27.8821806,135.995765 27.7727626,135.965042 27.5491277,136.11427 C27.2976584,136.281054 26.8791828,136.871822 26.555728,137.774212 C26.386802,138.242086 26.2188359,138.558976 26.1084581,138.769651 C26.0585482,138.863577 26.0115177,138.954869 26,138.995249","id":"Fill-67","fill":"#636362"}}),_c('path',{attrs:{"d":"M46.1868311,138.020688 L46.1447067,138.069651 C45.3467731,138.985251 43.3839375,141.384418 42.4021146,143.886406 C41.9120133,145.139032 41.8002216,146.608726 42.462871,146.904134 C43.1773658,147.22239 44.7951053,146.765406 46.5019541,145.275311 C47.1832355,144.680416 47.8313033,144.013709 48.4267157,143.294775 L48.6754118,142.995287 L48.5757713,143.348634 C48.0459758,145.228797 48.009522,146.737661 48.3092534,146.916374 C48.6162756,147.101616 49.5681253,146.738477 50.8496795,145.947731 C51.2790245,145.682517 51.6451828,145.370789 51.8452738,145.182283 C50.4260051,145.558478 50.1530065,145.516044 50.0752384,145.409959 C49.9577761,145.25083 49.9342836,144.745699 50.8043148,142.224126 C51.0846041,141.412979 51.4215994,140.617337 51.6670551,140.035499 C51.8274519,139.658487 51.9530151,139.359815 52,139.209663 C51.9756975,139.057063 51.3292497,138.047617 50.9752427,138.001103 C50.9485099,137.998655 50.8845132,137.990494 50.825377,138.109637 C50.8156559,138.128406 49.9877492,139.638902 49.1274391,141.749189 L49.1088072,141.775302 C47.5850375,143.108717 45.5387632,144.663279 44.4516293,144.503335 C44.3957335,144.496806 44.3179653,144.468245 44.2596392,144.385824 C44.0814205,144.132035 44.1818711,143.487361 44.5310176,142.660709 C44.6914144,142.280433 44.8955558,141.801416 45.0964569,141.329743 C45.4569446,140.483506 45.7979904,139.6846 45.8700879,139.489566 C46.1503773,138.734726 46.2192345,138.186345 46.1868311,138.020688","id":"Fill-69","fill":"#636362"}}),_c('path',{attrs:{"d":"M55.2543131,138.394986 C55.0972304,138.476541 54.9443034,139.699877 55.0199358,142.184129 C55.0955682,144.705161 55.4587699,146.87998 55.7089385,146.998316 C55.9624317,147.055085 57.8848241,145.674235 60.0981104,143.188384 C62.360433,140.648163 62.7336082,139.797424 62.7876314,139.548759 C62.991257,138.638054 63.0303199,138.123933 62.9804524,138 C62.645509,138.20309 61.1528082,139.715069 60.2817891,140.736115 C59.4431838,141.720381 57.2307287,143.58177 57.2091194,143.60096 L57.0636725,143.723294 L57.060348,143.559383 C57.060348,143.54499 57.0329209,142.101774 56.5857755,140.655359 C56.1328123,139.188955 55.858541,138.724407 55.2543131,138.394986 L55.2543131,138.394986 Z","id":"Fill-71","fill":"#636362"}}),_c('path',{attrs:{"d":"M68.1804249,138 C68.173187,138 68.1691659,138.000793 68.1667532,138.001585 L68.1345845,138.06342 C67.8265689,138.62944 67.2539655,139.681415 66.0122525,142.535301 C65.3278628,144.106524 64.8027082,145.177524 64.4552859,145.886239 C64.16818,146.472871 63.9952731,146.82485 64,146.926322 C64,146.931078 64.024225,146.954861 64.138424,146.974679 C64.7086147,147.071394 66.0958912,146.877172 66.2639728,146.627457 C66.5679673,146.174006 66.8558775,145.503343 67.4300893,144.168358 L67.5290081,143.938462 C68.4795941,142.215824 69.0851705,141.321606 70.5319591,140.547886 C71.5203434,140.018332 72.7588395,139.976316 73.6627808,139.945399 C74.0327212,139.932715 74.3519959,139.922409 74.5305323,139.877223 C75.0428194,139.74642 76.0577428,138.808601 75.9974264,138.519249 C75.9926011,138.498637 75.984559,138.455829 75.8566882,138.455829 L75.7207754,138.453451 C74.8586534,138.439181 72.2304681,138.397959 69.1768514,140.163404 L69.0039444,140.264083 L69.0473722,140.10157 C69.1615712,139.67428 69.241993,139.2787 69.2645112,139.017093 C69.2950714,138.684933 68.799673,138.270326 68.4554676,138.094337 C68.3002535,138.015855 68.2133979,138 68.1804249,138","id":"Fill-73","fill":"#636362"}}),_c('path',{attrs:{"d":"M86.1804249,138 C86.173187,138 86.1699701,138.000793 86.1667532,138.001585 L86.1345845,138.06342 C85.8265689,138.62944 85.2539655,139.681415 84.0122525,142.535301 C83.3278628,144.106524 82.8027082,145.177524 82.4552859,145.886239 C82.16818,146.472871 81.9952731,146.82485 82,146.926322 C82,146.931078 82.024225,146.954861 82.138424,146.974679 C82.7086147,147.071394 84.0958912,146.877172 84.2639728,146.627457 C84.5679673,146.174006 84.8558775,145.503343 85.4308935,144.168358 L85.5290081,143.938462 C86.4795941,142.215824 87.0851705,141.321606 88.5319591,140.547886 C89.5203434,140.018332 90.7588395,139.976316 91.6627808,139.945399 C92.0327212,139.932715 92.3519959,139.922409 92.5305323,139.877223 C93.0428194,139.74642 94.0577428,138.808601 93.9974264,138.519249 C93.9926011,138.498637 93.984559,138.455829 93.8566882,138.455829 L93.7207754,138.453451 C92.8586534,138.439181 90.2304681,138.397959 87.1768514,140.163404 L87.0039444,140.264083 L87.0473722,140.10157 C87.1615712,139.675865 87.2411888,139.280285 87.2661196,139.017093 C87.2958757,138.684933 86.799673,138.269534 86.4546634,138.093544 C86.3002535,138.015855 86.2133979,138 86.1804249,138","id":"Fill-75","fill":"#636362"}}),_c('path',{attrs:{"d":"M34.0117266,138.902483 C33.6779408,138.972262 32.1104152,140.041406 31.1834202,141.282191 C30.186288,142.616817 29.816166,143.971494 30.0848847,145.309328 C30.216709,145.967819 30.8335789,146.526853 31.7360681,146.806772 C33.0483955,147.21502 34.6835233,146.967986 36.1124645,146.145074 C38.8376776,144.576247 39.9057921,142.140394 39.9936749,140.531464 C40.0452216,139.57541 39.779883,138.824683 39.2644164,138.474183 C37.7543526,137.445142 35.4609484,138.381947 35.0173091,138.580055 C34.7257747,138.710791 34.6370468,138.825485 34.6505673,138.884838 C34.6556374,138.912108 34.6801432,138.91692 34.6877485,138.917722 C34.7190145,138.917722 34.890555,138.877619 35.0561804,138.83912 C35.6781205,138.693948 36.7183491,138.451726 37.1949445,138.651438 C37.5481659,138.798215 38.5917746,139.494402 37.1594533,142.219798 C35.9248684,144.568226 33.8190604,145.772918 32.5718001,145.536311 C31.8138106,145.395149 31.7842346,144.334827 32.4737769,142.101093 C32.9926237,140.419978 33.8883526,139.098185 33.8976479,139.085352 C33.9745454,138.985897 34.0015863,138.930555 34.0117266,138.902483","id":"Fill-77","fill":"#636362"}}),_c('path',{attrs:{"d":"M157.01178,138.902483 C156.677997,138.972262 155.110485,140.041406 154.183499,141.282191 C153.18553,142.616817 152.816257,143.971494 153.084973,145.309328 C153.216796,145.967819 153.83366,146.526853 154.736142,146.806772 C156.048457,147.21502 157.683571,146.967986 159.112499,146.145074 C161.836843,144.576247 162.905793,142.140394 162.993675,140.531464 C163.045221,139.57541 162.779885,138.824683 162.264423,138.474183 C160.754373,137.445142 158.460989,138.381947 158.017353,138.580055 C157.725822,138.710791 157.637095,138.825485 157.650615,138.884838 C157.655685,138.912108 157.680191,138.91692 157.687796,138.917722 C157.719061,138.917722 157.8906,138.877619 158.056224,138.83912 C158.678159,138.693948 159.718378,138.451726 160.194124,138.651438 C160.548188,138.798215 161.591787,139.494402 160.159479,142.219798 C158.924905,144.568226 156.819115,145.772918 155.571866,145.536311 C154.813883,145.395149 154.784308,144.334827 155.473844,142.101093 C155.992686,140.419978 156.888407,139.098185 156.897702,139.085352 C156.974599,138.985897 157.00164,138.930555 157.01178,138.902483","id":"Fill-79","fill":"#636362"}}),_c('path',{attrs:{"d":"M80.6875567,134.069562 C80.5251832,134.314196 80.164671,135.016305 80.0180341,135.652177 C79.8706818,136.287166 80.6632365,137.222428 81.0523608,136.952183 C81.4414851,136.681054 82.0208797,135.366035 81.9994206,135.119634 C81.9772463,134.875883 80.9293288,133.705702 80.6875567,134.069562","id":"Fill-81","fill":"#636362"}}),_c('path',{attrs:{"d":"M79.810678,138 L79.8044793,138 C79.7858832,138.045362 79.7106131,138.190358 79.5928375,138.419599 C78.9641109,139.639513 77.053136,143.356769 76.2951219,144.933099 C76.2729836,144.980891 76.2455322,145.031114 76.2163096,145.083766 C76.0684261,145.354318 75.8833502,145.691293 76.096763,146.110082 C76.4846254,146.874756 76.6581894,147.015702 76.7511701,146.998691 C76.9477579,146.906347 78.5691642,144.845615 79.605235,142.679579 C80.3712189,141.080567 81.1708529,139.34871 80.9680664,139.031176 C80.8060143,138.777635 80.0143501,138 79.810678,138","id":"Fill-83","fill":"#636362"}})])])])]),_c('p',{staticClass:"security-saving"},[_vm._t("default"),_c('span',[_vm._v(".")]),_c('span',[_vm._v(".")]),_c('span',[_vm._v(".")])],2)])}
var security_loadervue_type_template_id_532422b6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/plugin-security-agrial/common/security-loader.vue?vue&type=template&id=532422b6&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/common/security-loader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var security_loadervue_type_script_lang_js_ = ({
  name: 'SecurityLoader'
});
// CONCATENATED MODULE: ./src/plugin-security-agrial/common/security-loader.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_security_loadervue_type_script_lang_js_ = (security_loadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/plugin-security-agrial/common/security-loader.vue?vue&type=style&index=0&id=532422b6&lang=scss&scoped=true&
var security_loadervue_type_style_index_0_id_532422b6_lang_scss_scoped_true_ = __webpack_require__("ebc5");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/plugin-security-agrial/common/security-loader.vue






/* normalize component */

var component = normalizeComponent(
  common_security_loadervue_type_script_lang_js_,
  security_loadervue_type_template_id_532422b6_scoped_true_render,
  security_loadervue_type_template_id_532422b6_scoped_true_staticRenderFns,
  false,
  null,
  "532422b6",
  null
  
)

/* harmony default export */ var security_loader = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/views/login-auto.vue?vue&type=script&lang=js&
//
//
//
//


/* harmony default export */ var login_autovue_type_script_lang_js_ = ({
  name: 'LoginAuto',
  components: {
    SecurityLoader: security_loader
  },
  mounted: function mounted() {
    var _generateData = generateData(),
        state = _generateData.state,
        codeVerifier = _generateData.codeVerifier,
        codeChallenge = _generateData.codeChallenge;

    var params = {};
    var redirectUri = getUrlParameter(location.search, 'redirectFrom');

    if (redirectUri != null) {
      params.successRedirectUri = redirectUri;
    }

    getSecurityInfos(getRedirectRoute('redirect', params), state, codeChallenge).then(function (oidcUrl) {
      window.localStorage.setItem("oidc-".concat(state), codeVerifier);
      window.location = oidcUrl;
    }, function () {
      window.location = redirectUri != null ? redirectUri : "/login";
    });
  }
});
// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-auto.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_login_autovue_type_script_lang_js_ = (login_autovue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-auto.vue





/* normalize component */

var login_auto_component = normalizeComponent(
  views_login_autovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var login_auto = (login_auto_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"42fe2872-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/views/login-callback-popup.vue?vue&type=template&id=07a43950&
var login_callback_popupvue_type_template_id_07a43950_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SecurityLoader',[_vm._v("Authentification")])}
var login_callback_popupvue_type_template_id_07a43950_staticRenderFns = []


// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-callback-popup.vue?vue&type=template&id=07a43950&

// CONCATENATED MODULE: ./src/plugin-security-agrial/mixins/login-callback-mixin.js

/* harmony default export */ var login_callback_mixin = ({
  methods: {
    authorize: function authorize(redirectRoute, authorizationCode, codeVerifier) {
      return external_axios_default.a.get("/security/login-code", {
        params: {
          authorization_code: authorizationCode,
          code_verifier: codeVerifier,
          redirect_uri: "".concat(window.location.origin).concat(redirectRoute)
        }
      }).then(function (response) {
        var refreshToken = response.data.refreshToken;
        return refreshToken;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/views/login-callback-popup.vue?vue&type=script&lang=js&
//
//
//
//



/* harmony default export */ var login_callback_popupvue_type_script_lang_js_ = ({
  name: 'LoginCallbackPopup',
  components: {
    SecurityLoader: security_loader
  },
  mixins: [login_callback_mixin],
  mounted: function mounted() {
    if (window.opener) {
      var state = getUrlParameter(location.search, 'state');

      if (state != null) {
        var authorizationCode = getUrlParameter(location.search, 'code');

        if (window.opener["oidc-".concat(state)]) {
          var data = window.opener["oidc-".concat(state)];
          var codeVerifier = data.codeVerifier;
          this.authorize(getRedirectRoute('popup'), authorizationCode, codeVerifier).then(function (refreshToken) {
            window.localStorage.setItem('refreshToken', refreshToken);
            data.success();
          }, function (error) {
            data.failure(error.response);
          });
        }
      }
    } else {
      window.location = "/";
    }
  }
});
// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-callback-popup.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_login_callback_popupvue_type_script_lang_js_ = (login_callback_popupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-callback-popup.vue





/* normalize component */

var login_callback_popup_component = normalizeComponent(
  views_login_callback_popupvue_type_script_lang_js_,
  login_callback_popupvue_type_template_id_07a43950_render,
  login_callback_popupvue_type_template_id_07a43950_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var login_callback_popup = (login_callback_popup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"42fe2872-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/views/login-callback-redirect.vue?vue&type=template&id=755e6fdc&
var login_callback_redirectvue_type_template_id_755e6fdc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SecurityLoader',[_vm._v("Authentification")])}
var login_callback_redirectvue_type_template_id_755e6fdc_staticRenderFns = []


// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-callback-redirect.vue?vue&type=template&id=755e6fdc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugin-security-agrial/views/login-callback-redirect.vue?vue&type=script&lang=js&
//
//
//
//



/* harmony default export */ var login_callback_redirectvue_type_script_lang_js_ = ({
  name: 'LoginCallbackRedirect',
  components: {
    SecurityLoader: security_loader
  },
  mixins: [login_callback_mixin],
  mounted: function mounted() {
    var _this = this;

    var state = getUrlParameter(location.search, 'state');

    if (state != null) {
      var authorizationCode = getUrlParameter(location.search, 'code');
      var codeVerifier = window.localStorage.getItem("oidc-".concat(state));
      var params = {};

      if (this.$route.query != null && this.$route.query.successRedirectUri != null) {
        params.successRedirectUri = this.$route.query.successRedirectUri;
      }

      this.authorize(getRedirectRoute('redirect', params), authorizationCode, codeVerifier).then(function (refreshToken) {
        window.localStorage.setItem('refreshToken', refreshToken);
        var successRedirectUri;

        if (params.successRedirectUri != null) {
          try {
            var resolved = _this.$router.resolve(JSON.parse(params.successRedirectUri));

            successRedirectUri = resolved.href;
          } catch (e) {
            successRedirectUri = params.successRedirectUri;
          }
        } else {
          successRedirectUri = "/";
        }

        window.location = successRedirectUri;
      }, function () {
        window.location = "/login";
      });
    } else {
      window.location = "/login";
    }
  }
});
// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-callback-redirect.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_login_callback_redirectvue_type_script_lang_js_ = (login_callback_redirectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/plugin-security-agrial/views/login-callback-redirect.vue





/* normalize component */

var login_callback_redirect_component = normalizeComponent(
  views_login_callback_redirectvue_type_script_lang_js_,
  login_callback_redirectvue_type_template_id_755e6fdc_render,
  login_callback_redirectvue_type_template_id_755e6fdc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var login_callback_redirect = (login_callback_redirect_component.exports);
// CONCATENATED MODULE: ./src/plugin-security-agrial/index.js




var PluginSecurityAgrial = {
  install: function install(Vue, _ref) {
    var router = _ref.router,
        store = _ref.store;
    var oidcManager = new oidc_manager_default();
    store.registerModule('session', {
      namespaced: true,
      actions: {
        login: function login(context) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var mode = options.mode === 'redirect' ? 'redirect' : 'popup';

          switch (mode) {
            case 'redirect':
              return oidcManager.signinRedirect(options);

            default:
              return oidcManager.signinPopup(options);
          }
        },
        refresh: function refresh() {
          return oidcManager.refresh();
        },
        logout: function logout() {
          return oidcManager.signout();
        }
      }
    });
    var routes = [{
      path: "/login-auto",
      component: login_auto
    }, {
      path: "".concat("/login-callback", "-popup"),
      component: login_callback_popup
    }, {
      path: "".concat("/login-callback", "-redirect"),
      component: login_callback_redirect
    }];

    if (router.addRoute != null) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var route = _step.value;
          router.addRoute(route);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      router.addRoutes(routes);
    }
  }
};
/* harmony default export */ var plugin_security_agrial = (PluginSecurityAgrial);
// CONCATENATED MODULE: ./src/entry.js

/* harmony default export */ var entry = (plugin_security_agrial);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (entry);



/***/ })

/******/ });
//# sourceMappingURL=index.common.js.map